import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch, EBuyPackageStatus } from '../../../../types';
import { getErrorMessage } from './utils';
import {
  selectBuyPackageModalErrorMessage,
  selectIsBuyPackageModalLoading,
  selectIsSubscription,
} from '../../../../selectors/buyPackageModal';
import { buyPackageThunk } from '../../../../thunks';
import { setBuyPackageModalStatus } from '../../../../slices';
import spinImage from './assets/spin.png';
import { PaymentResult } from '../PaymentResult';

export const PaymentErrorContainer = () => {
  const isLoading = useSelector(selectIsBuyPackageModalLoading);
  const errorMessage = useSelector(selectBuyPackageModalErrorMessage);
  const isSubscription = useSelector(selectIsSubscription);

  const message = getErrorMessage(errorMessage);

  const dispatch = useDispatch<TDispatch>();

  const handleClick = React.useCallback(() => {
    if (isSubscription) {
      // Продление подписки
      dispatch(setBuyPackageModalStatus(EBuyPackageStatus.Loading));
      dispatch(buyPackageThunk());
    } else {
      dispatch(setBuyPackageModalStatus(EBuyPackageStatus.Confirm));
    }
  }, [dispatch, isSubscription]);

  return (
    <PaymentResult
      title="Что-то пошло не так"
      description={message}
      buttonTitle="Повторить"
      image={spinImage}
      isLoading={isLoading}
      onClick={handleClick}
    />
  );
};
